import { render, staticRenderFns } from "./FolderItem.vue?vue&type=template&id=0aa9078a&scoped=true"
import script from "./FolderItem.vue?vue&type=script&lang=js"
export * from "./FolderItem.vue?vue&type=script&lang=js"
import style0 from "./FolderItem.vue?vue&type=style&index=0&id=0aa9078a&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0aa9078a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/yogeshadhikari/Desktop/Projects/Scopic/picflow/picflow-fe/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0aa9078a')) {
      api.createRecord('0aa9078a', component.options)
    } else {
      api.reload('0aa9078a', component.options)
    }
    module.hot.accept("./FolderItem.vue?vue&type=template&id=0aa9078a&scoped=true", function () {
      api.rerender('0aa9078a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/templates/TemplateView/FolderItem.vue"
export default component.exports